export default __webpack_public_path__ + "static/media/Typescript_-_adamr.space___Codecademy.cbfea913.pdf";